// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"148":"f2a404ea","352":"18027b16"}[chunkId] + ".js";
};